import React, {useState, useEffect} from 'react'
//import "../../../sass/components/reuseable_components/_table_area.scss";

export default function BasicTableCell({data, label}) {
    return (
        <td data-label={label}>{data}</td>
    )
}
